module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-06.c133ede5.png";